import { VOICE_INSTRUCTIONS_MAX_LENGTH } from "@redotech/redo-concierge-settings-common/ai-tone-and-voice";
import * as z from "zod";

export const validateShopperAgentToneAndVoice = {
  name: "validateShopperAgentToneAndVoice" as const,
  input: z.object({
    /** Untrimmed, since the issues' offsets index into this text. */
    voiceInstructions: z.string().max(VOICE_INSTRUCTIONS_MAX_LENGTH),
  }),
  output: z.object({
    issues: z.array(
      z.object({
        start: z.number().int(),
        end: z.number().int(),
        message: z.string(),
        kind: z.string().optional(),
      }),
    ),
  }),
};
